import Scrollbar from 'mlmi-library/components/scrollbar/v1/scrollbar'
import { Carousel_CoreInit } from 'mlmi-library/components/carousel/v1/carousel'
import QRCode from 'qrcode'

function trackEvent(name, params) {
  if (typeof window.gtag !== 'function') return
  if (window._tnRestoring) return
  let payload = Object.assign({
    borne_id: window.tn_borne || '',
    lang: window.tn_lang || (window.bassaintlaurent_l10n && bassaintlaurent_l10n.LANGUAGE) || '',
  }, params || {})
  window.gtag('event', name, payload)
}
window.tnTrack = trackEvent

trackEvent('session_start', {
  timestamp: new Date().toISOString(),
  user_agent: navigator.userAgent,
})

document.addEventListener('click', function(e) {
  let langLink = e.target.closest('.header__lang-switch')
  if (!langLink) return
  let fromLang = window.tn_lang || ''
  let toLang = fromLang === 'fr' ? 'en' : 'fr'
  trackEvent('language_switch', { from_lang: fromLang, to_lang: toLang })

  /* Carry current state (active filter, view, open fiche) to the other language via the hash */
  let state = new URLSearchParams()
  let activeNav = document.querySelector('.header__nav-item.--active')
  if (activeNav) {
    state.set('nav', Array.prototype.indexOf.call(navItems, activeNav))
    state.set('view', currentView)
  }
  if (tnFiche && tnFiche.classList.contains('--displayed')) {
    let uid = currentFicheUid()
    if (uid) state.set('fiche', uid)
  }
  let serialized = state.toString()
  if (serialized) {
    e.preventDefault()
    window.location.href = langLink.getAttribute('href') + '#' + serialized
  }
})

/* Restore state carried over from a language switch (#nav=…&view=…&fiche=…) */
function restoreLangSwitchState() {
  if (!window.location.hash || window.location.hash.length < 2) return
  let state = new URLSearchParams(window.location.hash.substring(1))
  if (!state.has('nav') && !state.has('fiche')) return
  history.replaceState(null, '', window.location.pathname + window.location.search)
  window._tnRestoring = true

  let navIndex = parseInt(state.get('nav'), 10)
  if (!isNaN(navIndex) && navItems[navIndex]) {
    navItems[navIndex].click()
    if (state.get('view') === 'list') {
      let listBtn = document.querySelector('.tn-toolbar__view[data-view="list"]')
      if (listBtn) listBtn.click()
    }
  }
  let ficheUid = state.get('fiche')
  if (ficheUid) {
    loadFiche('/' + ficheUid + '/panel/', 'language_switch')
  }
  setTimeout(function() { window._tnRestoring = false }, 100)
}

const MAP_STYLE = [{"featureType":"all","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"all","elementType":"labels","stylers":[{"visibility":"off"},{"saturation":"-100"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40},{"visibility":"off"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"off"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#e8dbc3"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#ff0000"},{"lightness":20}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#1b3f47"}]},{"featureType":"landscape","elementType":"geometry.stroke","stylers":[{"color":"#4d6059"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"color":"#1b3f47"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#1b3f47"}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#7f8d89"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#7f8d89"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#292c2b"},{"lightness":"-1"},{"weight":"0.005"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#292c2b"},{"lightness":18},{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"saturation":"-26"},{"lightness":"-42"}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"lightness":"30"},{"saturation":"-82"},{"gamma":"1.40"},{"weight":"1.56"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#314e54"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#2b3638"},{"lightness":17}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#314e54"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.icon","stylers":[{"visibility":"off"}]}]

const MAP_OPTIONS = {
  selectors: {
    form: '.mlmi-locator-form',
    list: '.tn-list',
  },
  basicOptions: {
    zoom: 9,
    singleMapZoom: 9,
    maxZoom: 18,
    minZoom: 8,
    lat: 48.005275,
    lng: -69.045185,
    mapStyle: MAP_STYLE,
    autoFitBounds: true,
    enableGeolocation: false,
    putSearchParametersInURL: false,
    scrollwheel: false,
  },
  clusterOptions: {
    useClusters: true,
    styles: [{
      textColor: '#F4F2E0',
      textSize: 13,
      fontFamily: 'Poppins',
      lineHeight: 36,
      url: '/img/map/cluster-tn.svg',
      height: 36,
      width: 36,
      backgroundSize: '36px 36px',
      iconAnchor: [18, 18],
      anchor: [0, 0]
    }],
    gridSize: 100,
    maxZoom: 14,
    zoomOnClick: 1,
    averageCenter: 1,
    minimumMarkersToEnableClusters: 5,
    minimumClusterSize: 2
  },
  bubbleOptions: {
    useBubbles: false,
  },
  getMarkerIcon: function(data) {
    let markerIcon = {
      url: '/img/map/marker-tn.svg',
      height: 42,
      width: 30,
      anchorY: 42,
      anchorX: 15,
      scaledHeight: 42,
      scaledWidth: 30,
    }
    if ('featured' in data && data.featured) {
      markerIcon.url = '/img/map/marker-featured.svg'
      markerIcon.zIndex = 3000
    }
    return markerIcon
  },
  filterMarkers: function(markers) {
    let acceptedMarkers = []
    if (markers.length < 5) {
      return markers
    }
    markers.forEach((marker) => {
      if (marker.lng > -71 && marker.lng < -67) {
        acceptedMarkers.push(marker)
      }
    })
    return acceptedMarkers
  },
}

/* DOM elements */
const navItems = document.querySelectorAll('.header__nav-item')
const backBtn = document.querySelector('.tn-quick-links__back')
const fiches = document.querySelector('.tn-fiches')
const tnFiche = document.querySelector('.tn-fiche')
const bg = document.querySelector('.tn-background')
const video = bg ? bg.querySelector('video') : null
const viewBtns = document.querySelectorAll('.tn-toolbar__view')
const tnMap = document.querySelector('.tn-map')
const tnList = document.querySelector('.tn-list')
const zoomSlider = document.querySelector('.tn-toolbar__zoom-slider')
const scopeBtns = document.querySelectorAll('.tn-toolbar__scope')
const scopeGroup = document.querySelector('.tn-toolbar__group--scope')

function updateScopeSlider() {
  if (!scopeGroup) return
  const active = scopeGroup.querySelector('.tn-toolbar__scope.--active')
  if (!active) return
  scopeGroup.style.setProperty('--scope-x', active.offsetLeft + 'px')
  scopeGroup.style.setProperty('--scope-w', active.offsetWidth + 'px')
}

/* State */
let locatorInstance = null
let panel = null
let currentLocationIds = []
let currentView = 'map'
let listLoaded = false
let listRequest = null
let listScrollbar = null
let listOffset = 0
let listLocationIds = []
let activeMarker = null
const MARKER_FADE_DURATION = 200

/* Preload active marker icon to avoid first-touch fetch delay */
const _preloadActiveMarker = new Image()
_preloadActiveMarker.src = '/img/map/marker-tn-active.svg'

function animateOpacity(marker, from, to, duration, onDone) {
  let start = performance.now()
  function step(now) {
    let t = Math.min(1, (now - start) / duration)
    marker.setOpacity(from + (to - from) * t)
    if (t < 1) {
      requestAnimationFrame(step)
    } else if (onDone) {
      onDone()
    }
  }
  requestAnimationFrame(step)
}

function setActiveMarker(marker) {
  if (activeMarker === marker) return
  if (activeMarker) clearActiveMarker(true)

  activeMarker = marker
  if (!marker._activeIcon) return

  /* Create a red ghost marker overlaid on the original, fully opaque from the start */
  let ghost = new google.maps.Marker({
    position: marker.getPosition(),
    map: marker.getMap(),
    icon: marker._activeIcon,
    opacity: 1,
    zIndex: (marker.getZIndex() || 5000) + 1,
    clickable: false,
  })
  marker._ghost = ghost

  /* Wait for the ghost's DOM image to actually be in the page before fading the original out.
     Google Maps inserts an <img> in the markerLayer; we poll until it exists, then fade. */
  let attempts = 0
  function fadeOriginalWhenGhostReady() {
    let mapDiv = marker.getMap().getDiv()
    let imgs = mapDiv.querySelectorAll('img[src*="marker-tn-active.svg"]')
    let ready = false
    for (let i = 0; i < imgs.length; i++) {
      if (imgs[i].complete && imgs[i].naturalWidth > 0) { ready = true; break }
    }
    if (ready || attempts++ > 20) {
      animateOpacity(marker, 1, 0, MARKER_FADE_DURATION)
    } else {
      requestAnimationFrame(fadeOriginalWhenGhostReady)
    }
  }
  fadeOriginalWhenGhostReady()
}

function clearActiveMarker(immediate) {
  if (!activeMarker) return
  let marker = activeMarker
  let ghost = marker._ghost
  activeMarker = null

  if (!ghost) return

  if (immediate) {
    marker.setOpacity(1)
    ghost.setMap(null)
    marker._ghost = null
    return
  }

  /* Crossfade back: ghost 1→0, original 0→1 */
  animateOpacity(ghost, 1, 0, MARKER_FADE_DURATION)
  animateOpacity(marker, 0, 1, MARKER_FADE_DURATION, function() {
    ghost.setMap(null)
    marker._ghost = null
  })
}

/* Wait for MLMI_Locator_Function and google.maps to be available, then init */
function waitForLocator(callback) {
  if ('MLMI_Locator_Function' in window && typeof google !== 'undefined' && google.maps && google.maps.LatLng) {
    $.fn.MLMI_Locator = window.MLMI_Locator_Function
    callback()
  } else {
    setTimeout(() => waitForLocator(callback), 150)
  }
}

function initMap() {
  const $mapEl = $('.map-module__map')
  if (!$mapEl.length) return

  locatorInstance = $mapEl.MLMI_Locator(MAP_OPTIONS)

  /* Aucun contrôle natif Google Maps: le TN a son propre zoom (slider + tactile) */
  locatorInstance.map.setOptions({ disableDefaultUI: true })

  /* Panel */
  panel = $('.map-module__panel').LocatorPanel()

  /* "Ici" marker for borne location (custom overlay to stay above clusters) */
  if (window.tn_emplacement) {
    function IciMarker(map, position) {
      this.position = position
      this.setMap(map)
    }
    IciMarker.prototype = new google.maps.OverlayView()
    IciMarker.prototype.onAdd = function() {
      this.div = document.createElement('div')
      this.div.style.position = 'absolute'
      this.div.style.width = '54px'
      this.div.style.height = '54px'
      this.div.style.cursor = 'default'
      this.div.style.pointerEvents = 'none'
      let iciSvg = bassaintlaurent_l10n.LANGUAGE === 'en' ? 'here' : 'ici'
      this.div.innerHTML = '<img src="/img/map/' + iciSvg + '.svg" width="54" height="54">'
      this.getPanes().floatPane.appendChild(this.div)
    }
    IciMarker.prototype.draw = function() {
      var projection = this.getProjection()
      if (!projection || !this.div) return
      var point = projection.fromLatLngToDivPixel(this.position)
      if (point) {
        this.div.style.left = (point.x - 27) + 'px'
        this.div.style.top = (point.y - 27) + 'px'
      }
    }
    IciMarker.prototype.onRemove = function() {
      if (this.div) {
        this.div.parentNode.removeChild(this.div)
        this.div = null
      }
    }
    new IciMarker(locatorInstance.map, new google.maps.LatLng(tn_emplacement.lat, tn_emplacement.lng))
  }

  /* Marker click → open fiche */
  locatorInstance.on('marker_clicked', function(event, map, marker) {
    trackEvent('marker_click', {
      location_uid: marker.location.uid || String(marker.location.id || ''),
      location_name: marker.location.title || '',
    })
    loadFiche(marker.location.panel, 'map')
  })

  /* Map click → close panel */
  locatorInstance.map.addListener('click', function() {
    $('.map-module__panel__close').trigger('click')
  })

  /* Zoom controls */
  $('.tn-toolbar__zoom-out').on('click', function() {
    let targetZoom = locatorInstance.map.getZoom() - 1
    if (targetZoom >= MAP_OPTIONS.basicOptions.minZoom) {
      locatorInstance.map.setZoom(targetZoom)
    }
  })
  $('.tn-toolbar__zoom-in').on('click', function() {
    let targetZoom = locatorInstance.map.getZoom() + 1
    if (targetZoom <= MAP_OPTIONS.basicOptions.maxZoom) {
      locatorInstance.map.setZoom(targetZoom)
    }
  })

  /* Zoom slider */
  let zoomSliderActive = false
  if (zoomSlider) {
    zoomSlider.addEventListener('input', function() {
      locatorInstance.map.setZoom(parseInt(this.value))
    })
    /* Prevent Google Maps from capturing touch events on the slider */
    let stopProp = function(e) { e.stopPropagation() }
    zoomSlider.addEventListener('touchstart', function(e) {
      zoomSliderActive = true
      stopProp(e)
    })
    zoomSlider.addEventListener('touchmove', stopProp)
    zoomSlider.addEventListener('touchend', function(e) {
      stopProp(e)
      setTimeout(function() { zoomSliderActive = false }, 200)
    })
    zoomSlider.addEventListener('mousedown', function() { zoomSliderActive = true })
    zoomSlider.addEventListener('mouseup', function() {
      setTimeout(function() { zoomSliderActive = false }, 200)
    })
  }

  /* Zoom state — sync slider + buttons (skip slider sync while user is dragging it) */
  let zoomTrackTimer = null
  let lastTrackedZoom = locatorInstance.map.getZoom()
  locatorInstance.on('zoom_changed', function() {
    clearTimeout(zoomTrackTimer)
    zoomTrackTimer = setTimeout(function() {
      let z = locatorInstance.map.getZoom()
      if (z !== lastTrackedZoom) {
        trackEvent('zoom_change', {
          zoom_level: z,
          zoom_direction: z > lastTrackedZoom ? 'in' : 'out',
        })
        lastTrackedZoom = z
      }
    }, 400)
    setTimeout(function() {
      let currentZoom = locatorInstance.map.getZoom()
      $('.tn-toolbar__zoom-out').prop('disabled', currentZoom <= MAP_OPTIONS.basicOptions.minZoom)
      $('.tn-toolbar__zoom-in').prop('disabled', currentZoom >= MAP_OPTIONS.basicOptions.maxZoom)
      if (zoomSlider && !zoomSliderActive) {
        zoomSlider.value = currentZoom
      }
    }, 100)
  })

  /* Marker rollover z-index + active feedback (red icon while fiche is open) */
  let currentZ = 5000
  let warmupIcon = null
  locatorInstance.markers.forEach(function(marker) {
    google.maps.event.addListener(marker, 'mouseover', function() {
      marker.setOptions({ zIndex: currentZ++ })
    })
    marker._originalIcon = marker.getIcon()
    marker._activeIcon = Object.assign({}, marker._originalIcon, { url: '/img/map/marker-tn-active.svg' })
    if (!warmupIcon) warmupIcon = marker._activeIcon
    google.maps.event.addListener(marker, 'mousedown', function() {
      setActiveMarker(marker)
    })
  })

  /* Warm up red marker icon — Google Maps loads/parses the SVG before first real use */
  if (warmupIcon) {
    let warmup = new google.maps.Marker({
      position: locatorInstance.map.getCenter(),
      map: locatorInstance.map,
      icon: warmupIcon,
      opacity: 0,
      clickable: false,
      zIndex: -1,
    })
    setTimeout(function() { warmup.setMap(null) }, 500)
  }

  /* Hide all markers until a nav item is clicked */
  if (locatorInstance.clusterManager) {
    locatorInstance.clusterManager.clearMarkers()
    locatorInstance.clusterManager = undefined
  }
  locatorInstance.markers.forEach(function(marker) {
    marker.setMap(null)
  })

  /* Default: zoom to borne location */
  if (window.tn_emplacement) {
    locatorInstance.map.setCenter(new google.maps.LatLng(tn_emplacement.lat, tn_emplacement.lng))
    locatorInstance.map.setZoom(12)
  }
}

/* LocatorPanel (simplified from locator.js) */
$.fn.LocatorPanel = function() {
  let self = this
  self.cardRequest = undefined
  self.currentCard = undefined
  self.currentFragmentPath = undefined

  self.loadCard = function(fragmentPath) {
    if (self.currentFragmentPath === fragmentPath) return
    if (self.currentCard != undefined) self.closeCard()
    if (self.cardRequest != undefined) self.cardRequest.abort()
    self.cardRequest = $.get('/fragment/' + bassaintlaurent_l10n.LANGUAGE + fragmentPath, function(x) {
      let card = $('<div></div>').append(x)
      self.addCard(card.find('.card-panel'))
      self.cardRequest = undefined
    })
    self.currentFragmentPath = fragmentPath
  }

  self.addCard = function(newCard) {
    if (self.currentCard != undefined) self.closeCard()
    newCard.attr('aria-hidden', 'true')
    self.append(newCard)
    setTimeout(function() {
      self.currentCard = newCard
      self.currentCard.attr('aria-hidden', 'false')
    }, 50)
  }

  self.closeCard = function() {
    if (self.currentCard != undefined) {
      self.currentCard.attr('aria-hidden', 'true')
      let card = self.currentCard
      setTimeout(function() { card.remove() }, 400)
      self.currentCard = undefined
      clearActiveMarker()
    }
  }

  self.on('click', '.map-module__panel__close', function() {
    self.closeCard()
    self.currentFragmentPath = undefined
  })

  return self
}

/* Get marker IDs matching taxonomy filter slugs */
function getMarkerIdsByFilters(slugs) {
  if (!locatorInstance) return []
  var ids = []
  locatorInstance.markers.forEach(function(marker) {
    if (marker.location.filters) {
      for (var i = 0; i < slugs.length; i++) {
        if (marker.location.filters.indexOf(slugs[i]) !== -1) {
          ids.push(String(marker.location.id))
          return
        }
      }
    }
  })
  return ids
}

/* Get marker IDs matching a post type */
function getMarkerIdsByPostType(postType) {
  if (!locatorInstance) return []
  var ids = []
  locatorInstance.markers.forEach(function(marker) {
    if (marker.location.post_type === postType) {
      ids.push(String(marker.location.id))
    }
  })
  return ids
}

/* Filter map markers by post IDs */
function filterMarkersByIds(ids) {
  if (!locatorInstance) return

  let filteredMarkers = locatorInstance.markers.filter(function(marker) {
    return !ids.length || ids.indexOf(String(marker.location.id)) !== -1
  })

  /* Rebuild clusters with only the filtered markers */
  if (locatorInstance.clusterManager) {
    locatorInstance.clusterManager.clearMarkers()
  }
  if (filteredMarkers.length >= MAP_OPTIONS.clusterOptions.minimumMarkersToEnableClusters) {
    locatorInstance.clusterManager = new MarkerClusterer(locatorInstance.map, filteredMarkers, MAP_OPTIONS.clusterOptions)
  } else {
    /* Too few markers for clusters — show them directly */
    locatorInstance.clusterManager = undefined
    locatorInstance.markers.forEach(function(marker) { marker.setMap(null) })
    filteredMarkers.forEach(function(marker) { marker.setMap(locatorInstance.map) })
  }
}

/* Build list view via single batch AJAX (like main map) */
function buildListView() {
  if (!locatorInstance || !tnList) return

  listLocationIds = currentLocationIds.length ? currentLocationIds.map(Number) : locatorInstance.markers.map(function(m) { return m.location.id })

  /* Sort by distance from borne location */
  if (window.tn_emplacement && locatorInstance) {
    let markerMap = {}
    locatorInstance.markers.forEach(function(m) {
      markerMap[m.location.id] = {
        lat: m.position.lat(),
        lng: m.position.lng()
      }
    })
    let refLat = tn_emplacement.lat * Math.PI / 180
    let refLng = tn_emplacement.lng * Math.PI / 180
    listLocationIds.sort(function(a, b) {
      let ma = markerMap[a], mb = markerMap[b]
      if (!ma || !mb) return 0
      let dLatA = (ma.lat * Math.PI / 180) - refLat
      let dLngA = (ma.lng * Math.PI / 180) - refLng
      let distA = dLatA * dLatA + dLngA * dLngA * Math.cos(refLat) * Math.cos(refLat)
      let dLatB = (mb.lat * Math.PI / 180) - refLat
      let dLngB = (mb.lng * Math.PI / 180) - refLng
      let distB = dLatB * dLatB + dLngB * dLngB * Math.cos(refLat) * Math.cos(refLat)
      return distA - distB
    })
  }

  listOffset = 0

  if (!listLocationIds.length) {
    tnList.innerHTML = ''
    return
  }

  if (listRequest) listRequest.abort()

  /* Destroy previous scrollbar */
  if (listScrollbar) {
    listScrollbar.kill()
    listScrollbar = null
  }

  listRequest = $.post('/map-grid/', {
    action: 'get_grid',
    display_type: 'grid',
    language: bassaintlaurent_l10n.LANGUAGE,
    location_ids: listLocationIds,
    offset: 0
  }, function(html) {
    tnList.innerHTML = html
    listRequest = null

    /* Track offset from response */
    let $meta = $(tnList).find('[data-items-processed]')
    if ($meta.length) {
      listOffset += parseInt($meta.data('items-processed'), 10) || 0
    }

    /* Wrap content for scrollbar */
    let listWrapper = document.createElement('div')
    listWrapper.className = 'tn-list__inner'
    while (tnList.firstChild) {
      listWrapper.appendChild(tnList.firstChild)
    }
    tnList.appendChild(listWrapper)

    /* Initialize custom scrollbar */
    listScrollbar = new Scrollbar($(listWrapper), {
      direction: 'vertical',
      desktop: true,
      mobile: true,
    })

    /* Auto load more when scrolled to bottom */
    let scroller = listWrapper.querySelector('.scroller')
    if (scroller) {
      scroller.addEventListener('scroll', function() {
        if (scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 400) {
          let $btn = $(tnList).find('.map-module__load-more')
          if ($btn.length) {
            handleLoadMore($btn)
          }
        }
      })
    }
  })

  listLoaded = true
}

/* Load more items */
function handleLoadMore($btn) {
  if (listRequest || !listLocationIds.length) return

  trackEvent('list_load_more', { offset: listOffset })

  let $wrapper = $btn.closest('.map-module__load-more-wrapper')
  $btn.fadeOut(200, function() {
    $wrapper.html('<div style="display:flex;align-items:center;justify-content:center;padding:20px 0"><svg xmlns="http://www.w3.org/2000/svg" style="display:block;width:40px;height:40px" viewBox="0 0 100 100"><circle cx="50" cy="50" fill="none" stroke="#ccc" stroke-width="10" r="35" stroke-dasharray="165 57"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50"/></circle></svg></div>')

    listRequest = $.post('/map-grid/', {
      action: 'get_grid',
      display_type: 'grid',
      language: bassaintlaurent_l10n.LANGUAGE,
      location_ids: listLocationIds,
      offset: listOffset
    }, function(response) {
      listRequest = null

      let $response = $(response)

      /* Check for more */
      let $hasMore = $response.filter('[data-has-more]')
      let hasMore = $hasMore.length && $hasMore.data('has-more') === true

      /* Update offset */
      let $meta = $response.filter('[data-items-processed]')
      if ($meta.length) {
        listOffset += parseInt($meta.data('items-processed'), 10) || 0
      }

      /* Append new items to grid */
      let $newItems = $response.find('.grid__item')
      let $grid = $(tnList).find('.grid')
      $wrapper.remove()
      $grid.append($newItems)

      /* Add new load more if needed */
      if (hasMore) {
        let loadMoreText = bassaintlaurent_l10n.LANGUAGE === 'en' ? 'Load more' : 'Afficher plus'
        $grid.after('<div class="map-module__load-more-wrapper"><button class="map-module__load-more btn-primary">' + loadMoreText + '</button></div>')
      }

      /* Refresh scrollbar */
      if (listScrollbar) {
        listScrollbar.update()
      }
    })
  })
}

/* Smooth animated zoom */
function smoothZoom(targetZoom, targetCenter, callback) {
  if (!locatorInstance) return
  let map = locatorInstance.map
  let currentZoom = map.getZoom()

  if (targetCenter) {
    map.panTo(targetCenter)
  }

  if (currentZoom === targetZoom) {
    if (callback) callback()
    return
  }

  let step = targetZoom > currentZoom ? 1 : -1
  let listener = google.maps.event.addListener(map, 'zoom_changed', function() {
    let z = map.getZoom()
    if ((step > 0 && z < targetZoom) || (step < 0 && z > targetZoom)) {
      setTimeout(function() { map.setZoom(z + step) }, 60)
    } else {
      google.maps.event.removeListener(listener)
      if (callback) callback()
    }
  })
  map.setZoom(currentZoom + step)
}

/* Scope buttons (region / local) */
scopeBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    if (!btn.classList.contains('--active')) {
      trackEvent('scope_switch', { scope: btn.dataset.scope })
    }
    scopeBtns.forEach(b => b.classList.remove('--active'))
    btn.classList.add('--active')
    updateScopeSlider()
    if (!locatorInstance) return

    if (btn.dataset.scope === 'local' && window.tn_emplacement) {
      let target = new google.maps.LatLng(tn_emplacement.lat, tn_emplacement.lng)
      smoothZoom(12, target)
    } else {
      let target = new google.maps.LatLng(MAP_OPTIONS.basicOptions.lat, MAP_OPTIONS.basicOptions.lng)
      smoothZoom(MAP_OPTIONS.basicOptions.zoom, target)
    }
  })
})
updateScopeSlider()

/* List event delegation (load more + card click → panel) */
$(tnList).on('click', '.map-module__load-more', function(e) {
  e.preventDefault()
  handleLoadMore($(this))
})

$(tnList).on('click', '.card-location', function(e) {
  e.preventDefault()
  let uid = $(this).find('.favorite__toggle').data('content-uid')
  if (uid) {
    let name = ($(this).find('.card__title, .card-location__title, h2, h3').first().text() || '').trim()
    trackEvent('list_card_click', { location_uid: uid, location_name: name })
    loadFiche('/' + uid + '/panel/', 'list')
  }
})

/* Update fiche bar back button text based on current view */
function updateBackLabel() {
  let backLabel = tnFiche.querySelector('.tn-fiche-bar__back span')
  if (backLabel) {
    backLabel.textContent = currentView === 'list'
      ? (bassaintlaurent_l10n.LANGUAGE === 'en' ? 'Back to list' : 'Retour à la liste')
      : (bassaintlaurent_l10n.LANGUAGE === 'en' ? 'Back to map' : 'Retour à la carte')
  }
}

/* View toggle */
viewBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    if (!btn.classList.contains('--selected')) {
      trackEvent('view_switch', { view: btn.dataset.view })
    }
    viewBtns.forEach(b => b.classList.remove('--selected'))
    btn.classList.add('--selected')
    currentView = btn.dataset.view
    if (currentView === 'map') {
      tnMap.classList.add('--active')
      tnList.classList.remove('--active')
      fiches.classList.remove('--list-mode')
    } else {
      tnMap.classList.remove('--active')
      tnList.classList.add('--active')
      fiches.classList.add('--list-mode')
      /* Lazy load list only when switching to list view */
      if (!listLoaded) {
        buildListView()
      }
    }
    updateBackLabel()
  })
})

/* Nav item click */
navItems.forEach(btn => {
  btn.addEventListener('click', () => {
    if (!btn.classList.contains('--active')) {
      let filterType = btn.dataset.locationIds !== undefined ? 'location-ids'
        : btn.dataset.filters !== undefined ? 'filters'
        : btn.dataset.postType !== undefined ? 'post-type'
        : 'unknown'
      let filterName = (btn.querySelector('span') || {}).textContent || ''
      trackEvent('filter_click', {
        filter_name: filterName.trim(),
        filter_type: filterType,
      })
    }

    /* Click on already-active filter → close fiche if open, otherwise go back to home */
    if (btn.classList.contains('--active')) {
      if (tnFiche.classList.contains('--displayed')) {
        closeFiche()
        return
      }
      backBtn.click()
      return
    }

    let isFirstOpen = !fiches.classList.contains('--displayed')

    /* Close fiche if open */
    if (tnFiche.classList.contains('--displayed')) {
      closeFiche()
    }

    navItems.forEach(b => b.classList.remove('--active'))
    btn.classList.add('--active')
    document.body.classList.add('--nav-active')
    fiches.classList.add('--displayed')
    if (bg) bg.classList.add('--hidden')
    if (video) {
      setTimeout(() => video.pause(), 600)
    }

    /* Resolve location IDs based on button type */
    if (btn.dataset.locationIds) {
      currentLocationIds = btn.dataset.locationIds.split(',')
    } else if (btn.dataset.filters) {
      currentLocationIds = getMarkerIdsByFilters(btn.dataset.filters.split(','))
    } else if (btn.dataset.postType) {
      currentLocationIds = getMarkerIdsByPostType(btn.dataset.postType)
    } else {
      currentLocationIds = []
    }

    /* Apply filtering (skip autoFitBounds — we handle zoom ourselves) */
    filterMarkersByIds(currentLocationIds)
    listLoaded = false

    /* Keep current view, default to map on first open */
    if (isFirstOpen) {
      currentView = 'map'
    }
    if (currentView === 'map') {
      tnMap.classList.add('--active')
      tnList.classList.remove('--active')
      fiches.classList.remove('--list-mode')
    } else {
      tnMap.classList.remove('--active')
      tnList.classList.add('--active')
      fiches.classList.add('--list-mode')
      buildListView()
    }
    viewBtns.forEach(b => b.classList.remove('--selected'))
    document.querySelector('.tn-toolbar__view[data-view="' + currentView + '"]').classList.add('--selected')

    /* Trigger resize so map renders correctly, then zoom on first open */
    setTimeout(function() {
      if (locatorInstance) {
        google.maps.event.trigger(locatorInstance.map, 'resize')
      }
      if (isFirstOpen) {
        scopeBtns.forEach(b => b.classList.remove('--active'))
        let localBtn = document.querySelector('.tn-toolbar__scope[data-scope="local"]')
        if (localBtn) localBtn.classList.add('--active')
        updateScopeSlider()

        if (locatorInstance && window.tn_emplacement) {
          locatorInstance.map.setCenter(new google.maps.LatLng(tn_emplacement.lat, tn_emplacement.lng))
          locatorInstance.map.setZoom(12)
        }
      }
    }, 50)
  })
})

/* Logo → retour à l'accueil */
const logoEl = document.querySelector('.header__logo')
if (logoEl) {
  logoEl.addEventListener('click', () => backBtn.click())
}

/* Back button */
backBtn.addEventListener('click', () => {
  let activeNav = document.querySelector('.header__nav-item.--active span')
  let previousFilter = activeNav ? activeNav.textContent.trim() : ''
  trackEvent('back_to_home', { previous_filter: previousFilter })
  navItems.forEach(b => b.classList.remove('--active'))
  document.body.classList.remove('--nav-active')
  fiches.classList.remove('--displayed')
  if (bg) bg.classList.remove('--hidden')
  if (video) {
    video.play()
  }

  /* Close fiche if open — hide map instantly so it doesn't show through during fade */
  if (tnFiche.classList.contains('--displayed')) {
    fiches.style.display = 'none'
    closeFiche(true)
    setTimeout(() => { fiches.style.display = '' }, 450)
  }

  /* Close panel */
  if (panel) {
    $('.map-module__panel__close').trigger('click')
  }

  /* Reset filters */
  currentLocationIds = []
  listLoaded = false
})

/* Setup and display fiche content inside .tn-fiche */
function setupFiche() {
  if (!tnFiche || !tnFiche.querySelector('.fiche__container')) return

  /* Move media as first child of .fiche.fiche-location, wrap header+main in fiche-wrapper */
  let ficheLocation = tnFiche.querySelector('.fiche.fiche-location')
  let ficheMedia = tnFiche.querySelector('.fiche__header__media')
  if (ficheLocation && ficheMedia) {
    ficheLocation.insertBefore(ficheMedia, ficheLocation.firstChild)
  }
  let ficheHeader = tnFiche.querySelector('.fiche__header')
  let ficheMain = tnFiche.querySelector('.fiche__main')
  if (ficheHeader && ficheMain) {
    let wrapper = document.createElement('div')
    wrapper.className = 'fiche-wrapper'
    let wrapperClose = document.createElement('button')
    wrapperClose.className = 'fiche-wrapper__close icon-close'
    ficheHeader.parentNode.insertBefore(wrapper, ficheHeader)
    wrapper.appendChild(wrapperClose)
    wrapper.appendChild(ficheHeader)
    wrapper.appendChild(ficheMain)
  }

  tnFiche.classList.add('--displayed')
  document.body.classList.add('--nav-active')
  if (bg) bg.classList.add('--hidden')
  updateBackLabel()
  if (video) {
    setTimeout(() => video.pause(), 1200)
  }

  Carousel_CoreInit([], tnFiche)

  /* Match fiche-wrapper width to bar */
  let bar = tnFiche.querySelector('.tn-fiche-bar')
  let wrapper = tnFiche.querySelector('.fiche-wrapper')
  if (bar && wrapper) {
    wrapper.style.width = bar.offsetWidth + 'px'
  }

  /* Scrollbar on fiche main — if content doesn't overflow, set bottom:auto */
  let ficheMainEl = tnFiche.querySelector('.fiche__main')
  if (ficheMainEl && wrapper) {
    if (ficheMainEl.scrollHeight > ficheMainEl.clientHeight) {
      new Scrollbar($(ficheMainEl), {
        direction: 'vertical',
        desktop: true,
        mobile: true,
      })
    } else {
      wrapper.style.bottom = 'auto'
    }
  }

  /* Province + postal code on new line */
  let addressEl = tnFiche.querySelector('.fiche__header__address')
  if (addressEl) {
    let html = addressEl.innerHTML
    let match = html.match(/,\s*(QC|Québec|Quebec|[A-Z]{2})\s*,?\s*([A-Z]\d[A-Z]\s?\d[A-Z]\d)/i)
    if (match) {
      html = html.replace(match[0], '<br>' + match[1] + ' ' + match[2])
      addressEl.innerHTML = html
    }
  }

  /* Fill bar title and favorite uid from fiche content */
  let ficheTitle = tnFiche.querySelector('.fiche__header__title')
  let barTitle = tnFiche.querySelector('.tn-fiche-bar__title')
  if (ficheTitle && barTitle) {
    barTitle.textContent = ficheTitle.textContent
  }
  let ficheUid = tnFiche.querySelector('.fiche__container .favorite__toggle')
  let barFavorite = tnFiche.querySelector('.tn-fiche-bar__favorite')
  if (ficheUid && barFavorite) {
    let uid = ficheUid.getAttribute('data-content-uid')
    barFavorite.setAttribute('data-content-uid', uid)
    barFavorite.setAttribute('aria-pressed', tnFav.has(uid) ? 'true' : 'false')
  }
}

function cleanFicheContent() {
  let ficheContainer = tnFiche.querySelector('.fiche__container')
  if (ficheContainer) ficheContainer.remove()
  let ficheMedia = tnFiche.querySelector('.fiche__header__media')
  if (ficheMedia) ficheMedia.remove()
  let ficheWrapper = tnFiche.querySelector('.fiche-wrapper')
  if (ficheWrapper) ficheWrapper.remove()
}

function closeFiche(returnToHome, immediate) {
  if (tnFiche.classList.contains('--displayed')) {
    let barFav = tnFiche.querySelector('.tn-fiche-bar__favorite')
    let uid = barFav ? barFav.getAttribute('data-content-uid') : ''
    if (uid) trackEvent('fiche_close', { location_uid: uid })
  }
  tnFiche.classList.remove('--displayed', '--details')
  clearActiveMarker()
  if (returnToHome) {
    document.body.classList.remove('--nav-active')
    if (bg) bg.classList.remove('--hidden')
    if (video) video.play()
  }
  if (immediate) {
    cleanFicheContent()
  } else {
    setTimeout(cleanFicheContent, 450)
  }
}

function ficheUidFromPath(fragmentPath) {
  let match = (fragmentPath || '').match(/\/([^\/]+)\/(panel|fiche-tn)\//)
  return match ? match[1] : ''
}

/* Load fiche via AJAX from fragment path */
function loadFiche(fragmentPath, source) {
  let fichePath = fragmentPath.replace('/panel/', '/fiche-tn/')
  let uid = ficheUidFromPath(fragmentPath)
  if (uid) {
    trackEvent('fiche_open', {
      location_uid: uid,
      source: source || 'unknown',
    })
  }

  /* Move old content into a fading overlay, clean up after transition */
  let oldContent = tnFiche.querySelectorAll('.fiche__container, .fiche__header__media, .fiche-wrapper')
  if (oldContent.length) {
    let overlay = document.createElement('div')
    overlay.className = 'tn-fiche__old'
    overlay.style.cssText = 'position:absolute;top:0;left:0;right:0;bottom:0;z-index:0;opacity:1;transition:opacity .5s ease'
    oldContent.forEach(el => overlay.appendChild(el))
    tnFiche.appendChild(overlay)
    requestAnimationFrame(() => { overlay.style.opacity = '0' })
    setTimeout(() => overlay.remove(), 600)
  }

  tnFiche.classList.remove('--details')
  $.get('/fragment/' + bassaintlaurent_l10n.LANGUAGE + fichePath, function(html) {
    let bar = tnFiche.querySelector('.tn-fiche-bar')
    if (bar) {
      $(bar).after(html)
    } else {
      $(tnFiche).append(html)
    }
    setupFiche()
  })
}

function currentFicheUid() {
  let bar = tnFiche.querySelector('.tn-fiche-bar__favorite')
  return bar ? (bar.getAttribute('data-content-uid') || '') : ''
}

/* Toggle details */
$(tnFiche).on('click', '.tn-fiche-bar__toggle', function() {
  let willOpen = !tnFiche.classList.contains('--details')
  tnFiche.classList.toggle('--details')
  trackEvent(willOpen ? 'fiche_details_open' : 'fiche_details_close', {
    location_uid: currentFicheUid(),
  })
})
$(tnFiche).on('click', '.fiche-wrapper__close', function() {
  if (tnFiche.classList.contains('--details')) {
    trackEvent('fiche_details_close', { location_uid: currentFicheUid() })
  }
  tnFiche.classList.remove('--details')
})
$(tnFiche).on('click', '.fiche__header__media', function() {
  if (tnFiche.classList.contains('--details')) {
    trackEvent('fiche_details_close', { location_uid: currentFicheUid() })
  }
  tnFiche.classList.remove('--details')
})
$(tnFiche).on('click', '.swiper-button-next, .swiper-button-prev, .swiper-pagination-bullet', function() {
  let slide = tnFiche.querySelector('.swiper-slide-active')
  let idx = slide ? Array.prototype.indexOf.call(slide.parentNode.children, slide) : -1
  trackEvent('fiche_gallery_swipe', {
    location_uid: currentFicheUid(),
    slide_index: idx,
  })
})

$(tnFiche).on('click', '.tn-fiche-bar__back', function() {
  let hasActiveNav = document.querySelector('.header__nav-item.--active')
  if (!hasActiveNav) {
    closeFiche(true)
  } else {
    closeFiche()
  }
})

/* Open fiche from URL param (?fiche=ID) */
if (window.tn_fiche && tnFiche && tnFiche.querySelector('.fiche__container')) {
  setupFiche()
}

/* Favorites panel */
const tnFavorites = document.querySelector('.tn-favorites')
const favToggle = document.querySelector('.tn-favorites-toggle')
const favClose = document.querySelector('.tn-favorites__close')
const favList = document.querySelector('.tn-favorites__list')
const favCountEl = document.querySelector('.tn-favorites-toggle__count')
const favClearBtn = document.querySelector('.tn-favorites__clear')
const favEmpty = document.querySelector('.tn-favorites__empty')
let favScrollbar = null

const tnFav = {
  id: null,
  items: [],

  init() {
    this.id = localStorage.getItem('favorites_id')
    this.items = JSON.parse(localStorage.getItem('favorites_items') || '[]')
    if (!this.id) {
      this.id = this.generateUid()
      localStorage.setItem('favorites_id', this.id)
      localStorage.setItem('favorites_items', '[]')
    }
    this.updateCount()
    this.loadAll()
  },

  generateUid() {
    const chars = 'abdefil012345679'
    let s = ''
    while (s.length < 32) {
      let len = Math.floor(Math.random() * 13) + 4
      for (let i = 0; i < len; i++) s += chars.charAt(Math.floor(Math.random() * chars.length))
      s += '-'
    }
    return s.substring(0, 32).toLowerCase()
  },

  save() {
    localStorage.setItem('favorites_items', JSON.stringify(this.items))
  },

  has(uid) {
    return this.items.includes(uid)
  },

  updateEmpty() {
    if (!favEmpty) return
    if (this.items.length > 0) {
      favEmpty.classList.remove('--visible')
      if (favClearBtn) favClearBtn.style.display = ''
      $('.tn-favorites__footer').show()
    } else {
      favEmpty.classList.add('--visible')
      if (favClearBtn) favClearBtn.style.display = 'none'
      $('.tn-favorites__footer').hide()
    }
  },

  getListContainer() {
    if (!favList) return null
    let scroller = favList.querySelector('.scroller')
    return scroller ? $(scroller) : $(favList)
  },

  updateCount() {
    if (favCountEl) favCountEl.textContent = this.items.length
    this.updateEmpty()
    if (favToggle) {
      if (this.items.length > 0) {
        favToggle.classList.add('--has-items')
      } else {
        favToggle.classList.remove('--has-items')
      }
    }
  },

  add(uid, source) {
    if (this.has(uid)) return
    this.items.push(uid)
    this.save()
    this.updateCount()

    trackEvent('favorite_add', {
      location_uid: uid,
      source: source || 'unknown',
    })

    $.post('/favorites/', {
      action: 'add',
      list_uid: this.id,
      content_uid: uid,
      borne_id: window.tn_borne_id || 0,
    }, (html) => {
      let $container = this.getListContainer()
      if ($container) {
        let card = $('<div class="tn-favorites__item" data-uid="' + uid + '">').append(html).append('<button class="tn-favorites__item-remove icon-close"></button>')
        $container.prepend(card)
        this.updateScrollbar()
      }
    })
  },

  remove(uid) {
    this.items = this.items.filter(item => item !== uid)
    this.save()
    this.updateCount()

    trackEvent('favorite_remove', { location_uid: uid })

    if (favList) {
      $(favList).find('[data-uid="' + uid + '"]').remove()
      this.updateScrollbar()
    }

    $.post('/favorites/', {
      action: 'remove',
      list_uid: this.id,
      content_uid: uid,
      borne_id: window.tn_borne_id || 0,
    })
  },

  toggle(uid, source) {
    if (this.has(uid)) {
      this.remove(uid)
    } else {
      this.add(uid, source)
    }
  },

  loadAll() {
    if (!favList || !this.items.length) return
    let requests = this.items.map(uid => {
      return $.get('/fragment/' + bassaintlaurent_l10n.LANGUAGE + '/' + uid + '/fav_card/')
        .then(html => {
          let card = $('<div class="tn-favorites__item" data-uid="' + uid + '">').append(html).append('<button class="tn-favorites__item-remove icon-close"></button>')
          $(favList).append(card)
        })
        .fail(() => {
          this.items = this.items.filter(item => item !== uid)
        })
    })
    $.when.apply($, requests).always(() => {
      this.save()
      this.updateCount()
      this.updateScrollbar()
    })
  },

  clearAll() {
    trackEvent('favorites_clear', { favorites_count: this.items.length })
    this.items = []
    this.id = this.generateUid()
    localStorage.setItem('favorites_id', this.id)
    this.save()
    this.updateCount()
    if (favScrollbar) {
      favScrollbar.kill()
      favScrollbar = null
    }
    if (favList) $(favList).empty()
    $('.tn-favorites__share').hide()
    $('.tn-favorites__generate').show()
  },

  updateScrollbar() {
    if (!favList) return
    if (favScrollbar) {
      favScrollbar.update()
    } else {
      favScrollbar = new Scrollbar($(favList), {
        direction: 'vertical',
        desktop: true,
        mobile: true,
      })
    }
  },

  syncButton(uid) {
    let barFav = document.querySelector('.tn-fiche-bar__favorite')
    if (barFav && barFav.getAttribute('data-content-uid') === uid) {
      barFav.setAttribute('aria-pressed', this.has(uid) ? 'true' : 'false')
    }
  }
}

tnFav.init()

if (favToggle && tnFavorites) {
  favToggle.addEventListener('click', (e) => {
    e.stopPropagation()
    let wasOpen = tnFavorites.classList.contains('--open')
    tnFavorites.classList.toggle('--open')
    if (wasOpen) {
      trackEvent('favorites_panel_close', {})
    } else {
      trackEvent('favorites_panel_open', { favorites_count: tnFav.items.length })
    }
  })
  document.addEventListener('click', (e) => {
    if (tnFavorites.classList.contains('--open') && !tnFavorites.contains(e.target)) {
      trackEvent('favorites_panel_close', {})
      tnFavorites.classList.remove('--open')
    }
  })
}
if (favClose && tnFavorites) {
  favClose.addEventListener('click', () => {
    trackEvent('favorites_panel_close', {})
    tnFavorites.classList.remove('--open')
  })
}
if (favClearBtn) {
  favClearBtn.addEventListener('click', () => {
    tnFav.clearAll()
  })
}

$('.tn-favorites__generate').on('click', function() {
  let utm = '?utm_source=tableau-numerique&utm_medium=qr&utm_campaign=favoris'
    + '&utm_content=' + encodeURIComponent(window.tn_borne || '')
  let shareBase = $(this).data('share-base') || (window.location.origin + '/favoris/')
  let shareUrl = shareBase + tnFav.id + '/' + utm

  trackEvent('favorites_generate_qr', {
    favorites_count: tnFav.items.length,
    list_uid: tnFav.id,
  })

  let $btn = $(this)
  let $share = $('.tn-favorites__share')
  let $footer = $btn.closest('.tn-favorites__footer')
  let $qrLink = $share.find('.tn-favorites__share-qr')

  $qrLink.empty()
  QRCode.toDataURL(shareUrl, { width: 300, margin: 1 }, function(err, url) {
    if (!err) $qrLink.append('<img alt="QR Code" src="' + url + '">')
  })

  /* Measure footer heights */
  let startHeight = $footer.outerHeight()
  $btn.hide()
  $share.show().css('opacity', 0)
  let endHeight = $footer.outerHeight()
  $share.hide().css('opacity', '')
  $btn.show()

  /* Step 1: fade out button + grow footer simultaneously */
  $footer.css({ height: startHeight, overflow: 'hidden', transition: 'height .4s ease' })
  $btn.addClass('--fading-out')
  requestAnimationFrame(() => {
    $footer.css('height', endHeight)
  })

  /* Step 2: after grow, swap and fade in share */
  setTimeout(() => {
    $btn.hide().removeClass('--fading-out')
    $footer.css({ height: '', overflow: '', transition: '' })
    $share.show().addClass('--fading-in')
    requestAnimationFrame(() => {
      $share.removeClass('--fading-in')
      $qrLink.find('img').addClass('--loaded')
      tnFav.updateScrollbar()
    })
  }, 400)
})

$(document).on('click', '.tn-fiche-bar__favorite', function(e) {
  e.preventDefault()
  let uid = $(this).attr('data-content-uid')
  if (!uid) return
  tnFav.toggle(uid, 'fiche_bar')
  tnFav.syncButton(uid)
})

/* Open fiche from favorites list card click */
$(document).on('click', '.tn-favorites__item .card-location, .tn-favorites__item .card-panel', function(e) {
  e.preventDefault()
  let uid = $(this).find('.favorite__toggle').data('content-uid')
  if (uid) {
    tnFavorites.classList.remove('--open')
    loadFiche('/' + uid + '/panel/', 'favorites')
  }
})

/* Remove single favorite from list */
$(document).on('click', '.tn-favorites__item-remove', function(e) {
  e.stopPropagation()
  let uid = $(this).closest('.tn-favorites__item').data('uid')
  if (uid) tnFav.remove(uid)
})

/* Initialize map when locator library is ready */
waitForLocator(function() {
  initMap()
  restoreLangSwitchState()
})

/* Idle screen — shows after inactivity */
const IDLE_TIMEOUT = 3 * 60 * 1000
const IDLE_AUTO_RESET_TIMEOUT = 2 * 60 * 1000
const tnIdle = document.querySelector('.tn-idle')
let idleTimer = null
let idleAutoResetTimer = null

function resetSession() {
  tnFav.clearAll()
  navItems.forEach(b => b.classList.remove('--active'))
  document.body.classList.remove('--nav-active')
  fiches.classList.remove('--displayed')
  if (bg) bg.classList.remove('--hidden')
  if (video) video.play()
  if (tnFiche.classList.contains('--displayed')) {
    closeFiche(true, true)
  }
  if (panel) {
    $('.map-module__panel__close').trigger('click')
  }
  if (tnFavorites) tnFavorites.classList.remove('--open')
  currentLocationIds = []
  listLoaded = false
}

function resetIdleTimer() {
  clearTimeout(idleTimer)
  idleTimer = setTimeout(showIdle, IDLE_TIMEOUT)
}

function showIdle() {
  if (tnFav.items.length > 0) {
    if (tnIdle) {
      trackEvent('idle_screen_shown', { favorites_count: tnFav.items.length })
      tnIdle.setAttribute('aria-hidden', 'false')
      idleAutoResetTimer = setTimeout(() => {
        trackEvent('idle_reset', { source: 'auto', favorites_count: tnFav.items.length })
        resetSession()
        hideIdle()
      }, IDLE_AUTO_RESET_TIMEOUT)
    }
  } else {
    backBtn.click()
  }
}

function hideIdle() {
  if (tnIdle) tnIdle.setAttribute('aria-hidden', 'true')
  clearTimeout(idleAutoResetTimer)
  resetIdleTimer()
}

if (tnIdle) {
  document.addEventListener('click', resetIdleTimer)
  document.addEventListener('touchstart', resetIdleTimer)
  document.addEventListener('scroll', resetIdleTimer, true)

  tnIdle.querySelector('.tn-idle__continue').addEventListener('click', () => {
    trackEvent('idle_continue', {})
    hideIdle()
  })
  tnIdle.querySelector('.tn-idle__reset').addEventListener('click', () => {
    trackEvent('idle_reset', { source: 'user', favorites_count: tnFav.items.length })
    resetSession()
    hideIdle()
  })

  resetIdleTimer()
  window.showIdle = showIdle
}
